// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 8px 22px;
  background: var(--ion-color-white);
}
.header .ion-icon {
  width: 32px;
  height: 32px;
  cursor: pointer;
}

ion-content {
  --padding-start: 0;
  --padding-end: 0;
  --padding-top: 0;
  --background: transparent;
}

.main-container {
  display: none;
}
.main-container.show {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 42px;
}

.content {
  display: flex;
  align-items: center;
}

.section {
  width: 100%;
  min-width: 367px;
  max-width: 367px;
  overflow: hidden;
}
.section img {
  width: 100%;
  height: 100%;
  border-radius: 6px;
}

.carousel {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
}
.carousel .arrow {
  cursor: pointer;
  position: relative;
  top: -12px;
}
.carousel .arrow img {
  width: 30px;
  height: 30px;
}
.carousel .arrow.left {
  transform: rotate(90deg);
}
.carousel .arrow.right {
  transform: rotate(270deg);
}
.carousel .slides {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.carousel swiper-slide {
  width: 100% !important;
  height: auto;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
}
.carousel swiper-slide img {
  width: inherit;
  border-radius: 6px;
}
.carousel .welcome {
  position: relative;
}

.video {
  width: 100%;
  height: 100%;
  min-width: 367px;
  max-width: 367px;
  min-height: 367px;
  max-height: 367px;
}
.video .vimeo {
  min-width: 100%;
  min-height: 100%;
  object-fit: cover;
  border-radius: 6px;
}

.download {
  width: 100%;
  max-width: 367px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;
  border-radius: 5px;
  background: var(--ion-color-primary);
  cursor: pointer;
}
.download img {
  margin-right: 15px;
  max-width: 20px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/modal/gallery-detail-modal/gallery-detail-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,yBAAA;EACA,iBAAA;EACA,kCAAA;AACF;AACE;EACE,WAAA;EACA,YAAA;EACA,eAAA;AACJ;;AAGA;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;AAAF;;AAGA;EACE,aAAA;AAAF;AAEE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;AAAJ;;AAIA;EACE,aAAA;EACA,mBAAA;AADF;;AAIA;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AADF;AAGE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AADJ;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;AAFF;AAIE;EACE,eAAA;EACA,kBAAA;EACA,UAAA;AAFJ;AAII;EACE,WAAA;EACA,YAAA;AAFN;AAKI;EACE,wBAAA;AAHN;AAMI;EACE,yBAAA;AAJN;AAQE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AANJ;AAUE;EACE,sBAAA;EACA,YAAA;EACA,2BAAA;EACA,4BAAA;EACA,sBAAA;EACA,kBAAA;AARJ;AAUI;EACE,cAAA;EACA,kBAAA;AARN;AAYE;EACE,kBAAA;AAVJ;;AAeA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;AAZF;AAcE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAZJ;;AAiBA;EACE,WAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,oCAAA;EACA,eAAA;AAdF;AAgBE;EACE,kBAAA;EACA,eAAA;AAdJ","sourcesContent":[".header {\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n  padding: 8px 22px;\n  background: var(--ion-color-white);\n\n  .ion-icon {\n    width: 32px;\n    height: 32px;\n    cursor: pointer;\n  }\n}\n\nion-content {\n  --padding-start: 0;\n  --padding-end: 0;\n  --padding-top: 0;\n  --background: transparent;\n}\n\n.main-container {\n  display: none;\n\n  &.show {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 42px;\n  }\n}\n\n.content {\n  display: flex;\n  align-items: center;\n}\n\n.section {\n  width: 100%;\n  min-width: 367px;\n  max-width: 367px;\n  overflow: hidden;\n\n  img {\n    width: 100%;\n    height: 100%;\n    border-radius: 6px;\n  }\n}\n\n.carousel {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 20px;\n\n  .arrow {\n    cursor: pointer;\n    position: relative;\n    top: -12px;\n\n    img {\n      width: 30px;\n      height: 30px;\n    }\n\n    &.left {\n      transform: rotate(90deg);\n    }\n\n    &.right {\n      transform: rotate(270deg);\n    }\n  }\n\n  .slides {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n\n  swiper-slide {\n    width: 100% !important;\n    height: auto;\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: cover;\n    position: relative;\n\n    img {\n      width: inherit;\n      border-radius: 6px;\n    }\n  }\n\n  .welcome {\n    position: relative;\n  }\n\n}\n\n.video {\n  width: 100%;\n  height: 100%;\n  min-width: 367px;\n  max-width: 367px;\n  min-height: 367px;\n  max-height: 367px;\n\n  .vimeo {\n    min-width: 100%;\n    min-height: 100%;\n    object-fit: cover;\n    border-radius: 6px;\n  }\n}\n\n\n.download {\n  width: 100%;\n  max-width: 367px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 10px 20px;\n  border-radius: 5px;\n  background: var(--ion-color-primary);\n  cursor: pointer;\n\n  img {\n    margin-right: 15px;\n    max-width: 20px;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
